<app-modal *ngIf="vo$ | async; let vo" class="app-profile-selection-modal">
	<app-profiles
		modal-body
		[profiles]="vo.profiles"
		[columnModels]="vo.columnModels"
		[mode]="'SIMULATION'"
		[selectedId]="vo.selectedProfileId"
		(reloadProfiles)="refreshProfiles()"></app-profiles>

	<div modal-footer class="app-profile-selection-modal__footer">
		<div
			*ngIf="vo.error"
			class="error-alert error">
			<mat-icon
				[ngClass]="{ 'warning': vo.error.type === 'warning' }"
				color="warn"
				[svgIcon]="vo.error.type === 'critic'? DcIcons.Error: DcIcons.Warning"></mat-icon>
			<span>{{vo.error.message}}</span>
		</div>

		<button
			id="{{ cmpId }}-validate-btn"
			[disabled]="vo.error !== undefined"
			[color]="'primary'"
			(click)="launchAction()"
			mat-raised-button>
			<span
				i18n="@@subscription.simulator.simulate.btn">
				simulate</span>
		</button>
	</div>
</app-modal>
